import { render } from "./CreateReceiptProject.vue?vue&type=template&id=3cf0b1b8&scoped=true"
import script from "./CreateReceiptProject.vue?vue&type=script&lang=js"
export * from "./CreateReceiptProject.vue?vue&type=script&lang=js"

import "./CreateReceiptProject.vue?vue&type=style&index=0&id=3cf0b1b8&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf0b1b8"]])

export default __exports__